import { CaseAdmin, Clinic, Lab } from "pwapi";

import { LabList } from "custom-models/frontLoader";

import { useAppSelector } from "store/hooks";

export const useAllowsExternalAccession = ({
  clinic,
  grossed_by_external_lab_id,
  accessioning_lab,
  case_type,
  remains_digital_pc,
}: {
  clinic?: Clinic;
  grossed_by_external_lab_id?: number;
  accessioning_lab?: Lab | LabList;
  case_type?: CaseAdmin.type;
  remains_digital_pc?: boolean;
}) => {
  const externalLab = useAppSelector(({ externalLabs }) =>
    externalLabs && externalLabs[grossed_by_external_lab_id || -1]
      ? externalLabs[grossed_by_external_lab_id || -1]
      : undefined
  );

  return (
    clinic?.name?.includes("Utah Valley Dermatology") ||
    clinic?.name?.includes("Bernhardt") ||
    (clinic?.name?.includes("Rocky Mountain Dermatology") &&
      case_type === CaseAdmin.type.TC_PC) ||
    externalLab?.name?.includes("Seacoast") ||
    externalLab?.name?.includes("Sutton Dermatology") ||
    externalLab?.name?.includes("Skin Care Doctors") ||
    externalLab?.name?.includes("Bernhardt") ||
    externalLab?.name?.includes("Dermatology Associates") ||
    externalLab?.name?.includes("Paducah Dermatology") ||
    externalLab?.name?.includes("Integrated Dermatology") ||
    case_type === CaseAdmin.type.HISTORICAL ||
    accessioning_lab?.settings?.digital_pc?.active ||
    remains_digital_pc
  );
};
